module.exports = __webpack_public_path__ + "static/media/draw.1d10f376.svg";